<div class="break_pages px-0" style="background-color:white;color:black" *ngIf="store_sale_report">
	<div class="header-container">
		<div class="logo-section">
			<img [src]="rest.getImagePath(store.ticket_image_id, rest.local_preferences.default_ticket_image_id)" class="image_logo_ticket">
		</div>
		<div class="d-print-none text-center my-3">
			<div class="btn-group me-2">
				<button type="button" class="btn btn-outline-primary" (click)="print()">
					<svg xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 100 100"><path fill="currentColor" d="M90.443 35.141a1.825 1.825 0 0 0-1.818-1.708H75.511V11.857c0-1.012-.819-1.83-1.83-1.83H26.319c-1.011 0-1.83.818-1.83 1.83v21.576H11.375c-.969 0-1.754.755-1.818 1.708h-.012V71.91a1.83 1.83 0 0 0 1.83 1.829h13.114V58.425H75.51v15.314h13.114a1.83 1.83 0 0 0 1.83-1.829V35.141h-.011zm-19.919 6.49H29.476V16.844c0-1.012.819-1.83 1.83-1.83h37.387c1.011 0 1.83.818 1.83 1.83v24.787z"/><path fill="currentColor" d="M29.602 88.143c0 1.012.819 1.83 1.83 1.83h37.136c1.011 0 1.83-.818 1.83-1.83v-24.64H29.602v24.64z"/></svg>
					Imprimir
				</button>
				<button class="btn btn-outline-primary" (click)="gotoPaymentAbonos()">Pagos Abonos</button>
				<button class="btn btn-outline-primary" (click)="gotoOrderAbonos()">Ordenes Abonos</button>
				<button class="btn btn-outline-primary" (click)="gotoOrderCreditos()">Ordenes Creditos</button>
				<button class="btn btn-outline-primary" (click)="gotoOrdersWithDiscount()">Ordenes con Descuento</button>
			</div>
		</div>
		<div class="info-section">
			<div class="fw-bold">Sucursal {{store.name}}</div>
			<div class="pb-3" *ngIf="billing_data.id == 0">
				<div>{{store.business_name}}</div>
				<div>{{store.rfc}}</div>
				<span>{{store.name}}&nbsp;</span>
				<span *ngIf="store?.address">{{store.address}}&nbsp;</span>
				<span *ngIf="store?.city">,{{store.city | titlecase}}&nbsp;</span>
				<span *ngIf="store?.state">,{{store.state | titlecase}}&nbsp;</span>
				<span *ngIf="store?.zipcode">,{{store.zipcode| titlecase}}&nbsp;</span>
			</div>
			<div class="" style="text-transform:uppercase" *ngIf="billing_data">
				<div>{{billing_data.razon_social}} {{billing_data.regimen_capital}}</div>
				<div>{{billing_data.rfc}}</div>
				<div>
					<span *ngIf="billing_data.address">{{billing_data.address}}&nbsp;</span>
					<span *ngIf="billing_data?.city">,{{billing_data.city | titlecase}}&nbsp;</span>
					<span *ngIf="billing_data?.state">,{{billing_data.state| titlecase}}&nbsp;</span>
				</div>
				<div>{{billing_data.zipcode | titlecase}}&nbsp;</div>
			</div>
			<span *ngIf="store.phone">Tel: {{store.phone}}</span>
		</div>
	</div>
	<table class="border">
		<thead>
			<tr>
				<th>#{{store_sale_report?.id}}</th>
				<th class="text-end">{{store_sale_report?.date | date: 'd/MMM/Y'}}</th>
			</tr>
			<tr class="">
				<th>{{store_sale_report.start_timestamp | shortDate:'full'}}</th>
				<th class="text-end">{{store_sale_report.end_timestamp | shortDate:'full'}}</th>
			<tr>
				<th colspan=2>
					<h2>Ventas ({{order_info_list.length}})</h2>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr class="">
				<td class="w-50">Subtotal</td>
				<th class="text-end">{{total-order_discounts-tax-ieps|currency}}</th>
			</tr>
			<tr>
				<td class="w-25">IVA</td>
				<th class="text-end">{{tax|currency}}</th>
			</tr>
			<tr *ngIf="ieps>0">
				<td class="w-25">IEPS</td>
				<th class="text-end">{{ieps|currency}}</th>
			</tr>
			<tr>
				<td class="w-25">Total</td>
				<th class="text-end">{{total-order_discounts |currency}}</th>
			</tr>
		</tbody>
	</table>

	<table class="border my-3" *ngIf="this.rest.local_preferences.default_cash_close_receipt == 1 || this.rest.local_preferences.default_cash_close_receipt ==3">
		<thead>
			<tr>
				<th colspan="3 border">
					<h2>Ventas por categoría</h2>
				</th>
			</tr>
			<tr>
				<th>Categoria</th>
				<th class="border text-end w-25">Cantidad</th>
				<th class="border text-end w-25">Total</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let cr of category_resume_list">
				<td class="border">{{cr.name}}</td>
				<td class="border text-end w-25">{{cr.qty | number}}</td>
				<td class="border text-end w-25">{{cr.total | currency}}</td>
			</tr>
		</tbody>
	</table>
	<table class="border my-3">
		<thead>
			<tr>
				<th>Impuesto</th>
				<th class="text-end w-25">Artículos</th>
				<th class="text-end w-25">Total</th>
				<th class="text-end w-25 d-print-none">Acciones</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let cr of tax_resume_list">
				<td class="border">{{cr.name}}</td>
				<td class="border text-end w-25">{{cr.qty | number}}</td>
				<td class="border text-end w-25">{{cr.total | currency}}</td>
				<td class="border text-end w-25 d-print-none">
					<button
						class="btn btn-sm btn-outline-primary"
						(click)="gotoItemsByTax(cr.name)"
						title="Ver artículos con {{cr.name}}">
						<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
							<path fill="currentColor" d="M12 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m0 8a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5a5 5 0 0 1-5 5m0-12.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5Z"/>
						</svg>
						Ver
					</button>
				</td>
			</tr>
		</tbody>
	</table>

	<div class="row-balance-creditos my-3">
		<div class="col-balance">
			<table class="border">
				<!--tr>
					<th>Ventas</th>
					<td>{{total-discounts|currency}}</td>
				</tr-->
				<thead>
					<tr>
						<th colspan=2>
							<h2>Balance</h2>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Retiros</td>
						<th class="text-end">{{total_expenses | currency}}</th>
					</tr>
					<tr>
						<td>Descuentos</td>
						<th class="text-end">{{discounts| currency}}</th>
					</tr>
					<tr>
						<td>Total</td>
						<th class="text-end">{{box_amount | currency}}</th>
					</tr>
					<tr>
						<td>Total en Caja</td>
						<th class="text-end">{{total_caja_real | currency}}</th>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="col-creditos">
			<table class="border">
				<tr class="">
					<td colspan="2">
						<h2>Creditos</h2>
					</td>
				</tr>
				<tr>
					<td>Ventas</td>
					<th class="text-end">
						{{count_credit}}
					</th>
				</tr>
				<tr>
					<td>Total</td>
					<th class="text-end">
						{{total_credit | currency}}
					</th>
				</tr>
			</table>
		</div>
	</div>

	<div class="row-ingresos my-3">
		<div class="col-ingresos-ventas">
			<table class="border">
				<tr class="">
					<td colspan="2">
						<h2>Ingresos Ventas</h2>
					</td>
				</tr>
				<tr *ngFor="let payment_entry of payment_entries">
					<td>
						{{payment_entry.name}}
						<b *ngIf="payment_entry.currency_id=='USD'">({{payment_entry.amount | currency}} USD)</b>
					</td>
					<th class="text-end">
						<span *ngIf="payment_entry.currency_id=='MXN'">
							{{payment_entry.amount | currency}} {{payment_entry.currency_id}}
						</span>
						<span *ngIf="payment_entry.currency_id=='USD'">
							{{ventas_usd_mxn | currency}} MXN
						</span>
					</th>
				</tr>
				<tr>
					<th>T.Ingreso Ventas</th>
					<th class="text-end">{{total_i_ventas | currency}} MXN</th>
				</tr>
			</table>
		</div>
		<div class="col-ingresos-abonos">
			<table class="border">
				<tr class="">
					<td colspan="2">
						<h2>Ingresos Abonos</h2>
					</td>
				</tr>
				<tr *ngFor="let payment_entry of other_payment_entries">
					<td>
						{{payment_entry.name}}
						<b *ngIf="payment_entry.currency_id=='USD'">({{payment_entry.amount | currency}} USD)</b>
					</td>
					<th class="text-end">
						<span *ngIf="payment_entry.currency_id=='MXN'">
							{{payment_entry.amount | currency}} {{payment_entry.currency_id}}
						</span>
						<span *ngIf="payment_entry.currency_id=='USD'">
							{{abonos_usd_mxn | currency}} MXN
						</span>
					</th>
				</tr>
				<tr>
					<th>T.Ingreso Abonos</th>
					<th class="text-end">{{total_abonos | currency}} MXN</th>
				</tr>
			</table>
		</div>
	</div>

	<table class="border">
		<tr class="">
			<td colspan="2">
				<h2>Total Ingresos</h2>
			</td>
		</tr>
		<tr *ngFor="let payment_entry of all_payment_entries">
			<td>
				{{payment_entry.name}}
				<b *ngIf="payment_entry.currency_id=='USD'">({{payment_entry.amount | currency}} USD)</b>
			</td>
			<th class="text-end">
				<span *ngIf="payment_entry.currency_id=='MXN'">
					{{payment_entry.amount | currency}} {{payment_entry.currency_id}}
				</span>
				<span *ngIf="payment_entry.currency_id=='USD'">
					{{total_usd_mxn | currency}} MXN
				</span>
			</th>
		</tr>
		<tr>
			<th>Total</th>
			<th class="text-end">{{big_total | currency}} MXN</th>
		</tr>

	</table>
<!--
{{total|currency}} <br>
{{subtotal | currency}} <br>
{{iva | currency}} <br>
{{amount_paid | currency }}<br>
<table>
	<tr>
		<th class="text-end px-3">id</th>
		<th class="text-end px-3">Total</th>
		<th class="text-end px-3">Descuento</th>
		<th class="text-end px-3">Subtotal</th>
		<th class="text-end px-3">Tax</th>
		<th class="text-end px-3">Tax 2</th>
	</tr>
	<tr *ngFor="let oi of order_info_list">
		<td class="text-end px-3">{{oi.order.id}}</td>
		<td class="text-end px-3">{{oi.order.total}}</td>
		<td class="text-end px-3">{{oi.order.discount}}</td>
		<td class="text-end px-3">{{oi.order.subtotal | number:'1.2-2'}}</td>
		<td class="text-end px-3">{{oi.order.subtotal*0.08 | number:'1.2-2'}}</td>
		<td class="text-end px-3">{{oi.order.tax | number:'1.2-2'}}</td>
	</tr>
</table-->
</div>
